import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useMinicrmMigrationStore } from '../../../store/minicrmMigrationStore';
import type { OrgSearchResult } from '../../../types/minicrmMigration';

interface Props { miniSchoolString: string; onPick: (orgId: string) => void; onClose: () => void; }

export function OrgSearchModal({ miniSchoolString, onPick, onClose }: Props) {
  const { searchOrgs } = useMinicrmMigrationStore();
  const [q, setQ] = useState('');
  const [results, setResults] = useState<OrgSearchResult[]>([]);

  useEffect(() => {
    let cancelled = false;
    const t = setTimeout(async () => {
      if (q.length >= 2) {
        const r = await searchOrgs(q);
        if (!cancelled) setResults(r);
      } else {
        setResults([]);
      }
    }, 200);
    return () => { cancelled = true; clearTimeout(t); };
  }, [q, searchOrgs]);

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-md p-4" role="dialog" aria-modal="true">
        <div className="flex items-center justify-between mb-3">
          <div className="font-medium">Pick a school org</div>
          <button type="button" onClick={onClose}><X className="h-4 w-4" /></button>
        </div>
        <div className="text-xs text-gray-500 mb-2">For Mini school <strong>{miniSchoolString}</strong></div>
        <input autoFocus className="w-full border rounded px-3 py-2 text-sm" placeholder="Search by name or city…" value={q} onChange={(e) => setQ(e.target.value)} />
        <div className="mt-3 max-h-64 overflow-y-auto divide-y">
          {results.map((o) => (
            <button type="button" key={o.id} className="w-full text-left px-3 py-2 hover:bg-gray-50 text-sm" onClick={() => onPick(o.id)}>
              <div className="font-medium">{o.name}</div>
              <div className="text-xs text-gray-500">{[o.city, o.state].filter(Boolean).join(', ') || '—'} · {o.source}</div>
            </button>
          ))}
          {q.length >= 2 && results.length === 0 && <div className="px-3 py-2 text-sm text-gray-500">No matches.</div>}
        </div>
      </div>
    </div>
  );
}
